import ITask from '../../../Utility/Task/ITask';
import { PlayerTask } from '../../../State/Player/PlayerTasks';
import RewardAnimationHelper from './RewardAnimationHelper';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import FarmSystem from 'System/Farm/FarmSystem';

export default class FarmRewardSyncTask implements ITask<FarmSystem> {
    public *execute(system: FarmSystem): IterableIterator<number> {
        const target = system.getRewardContainer();
        const tasksToClear = [];
        for (const taskData of system.store.getState().playerState.tasks) {
            const newTaskData = {
                ...taskData,
                animateDown: true,
            }
            let clearTask: boolean = true;
            switch (taskData.task) {
                case PlayerTask.COIN:
                    RewardAnimationHelper.coins(system, newTaskData, target);
                    break;
                case PlayerTask.TNT:
                    RewardAnimationHelper.boosterTNT(system, newTaskData, target);
                    break;
                case PlayerTask.BULLS_EYE:
                    RewardAnimationHelper.boosterBullsEye(system, newTaskData, target);
                    break;
                case PlayerTask.SHUFFLE:
                    RewardAnimationHelper.boosterShuffle(system, newTaskData, target);
                    break;
                case PlayerTask.JOKER:
                    RewardAnimationHelper.jokers(system, newTaskData, target);
                    break;
                case PlayerTask.EXTRA_CARDS:
                    RewardAnimationHelper.extraCards(system, newTaskData, target);
                    break;
                case PlayerTask.UNDO:
                    RewardAnimationHelper.boosterUndo(system, newTaskData, target);
                    break;
                case PlayerTask.FREE_PLAY_REWARD:
                    RewardAnimationHelper.freePlay(system, newTaskData, target);
                    break;
                case PlayerTask.REWARD_BOOSTER:
                    RewardAnimationHelper.rewardAnyBooster(system, newTaskData, target);
                    break;
                default:
                    clearTask = false;
                    break;
            }

            if (clearTask) {
                tasksToClear.push(taskData);
            }
        }

        if (tasksToClear.length > 0) {
            PlayerActions.clearTasks(tasksToClear);
        }
    }
}
